import { Dispatch } from "redux";
import { SET_LOGIN_PAGE } from "../reducers/loginPage";

export const setLoginPage = (loginPage: string) => {
  return async (dispatch: Dispatch) => {
    return dispatch(getSetLoginPageAction(loginPage));
  };
};

export const getSetLoginPageAction = (loginPage: string) => {
  return {
    type: SET_LOGIN_PAGE,
    loginPage,
  };
};
